module.exports = __webpack_public_path__ + "9385d5bc12eb4181e51980a69c2a9e06.svg";